import {
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from 'react-router-dom';
import Card from '../components/Card';
import { useFetcher } from '../hooks/useFetcher';
import Pagination from '../components/Pagination';
import { useEffect, useState } from 'react';

const Products = ({search}) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [cart, setCart] = useState(null);

  const path = location.pathname.split('/');

  let url = null;

  if(search) {
    //console.log(searchParams.get('page'));
    url = `search?q=${params.name}&page=${searchParams.get('page') || 1}`
  } else {
    url = path.includes('cat')
    ? `products?cat=${params.id}&page=${searchParams.get('page')}&webapi`:
    (params.id=='specials')?`products?${params.id}&page=${searchParams.get('page')||1}`
    : `home/${params.id}?page=${searchParams.get('page') || 1}`;
  }

  //console.log(url);
  const [data, loading] = useFetcher(url);

  // const [data, loading] = useFetcher(`products?cat=${params.id}&asc`);

  const onPageChange = (pageNumber) => {
    //console.log(data);
    if(search) {
      navigate(
        `/search/${
          params.name
        }?page=${pageNumber}`
      );
    } else {
      navigate(
        `/products${path.includes('cat') ? '/cat/' : '/'}${
          params.id
        }?page=${pageNumber}`
      );
    }
  };

  const isInArray = (source, item) => {
    const checkId = (obj) => obj.id === item.id;
    return source.some(checkId);
  };

  const addToCart = (item) => {
    let newData = [];
    const lsData = JSON.parse(localStorage.getItem('products'));

    if (lsData) {
      if (isInArray(lsData, item)) {
        newData = lsData.filter((product) => product.id !== item.id);
      } else {
        

        newData = [...lsData, item];
      }
    } else {
      newData = [item];
    }
    let counterss=0
    newData.map(()=>{
      counterss++;
    })
    document.querySelector(".cart-number").innerHTML=counterss;
    setCart(newData);
    localStorage.setItem('products', JSON.stringify(newData));
  };

  useEffect(() => {
    setCart(() => {
      return JSON.parse(localStorage.getItem('products'));
    });
  }, []);

  if (loading) {
    return <div className='lds-dual-ring'></div>;
  }

  return (
    <>
      
      <div className="navig w-full grid grid-cols-2 justify-items-center p-10 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
        {!loading && (
          <>
            {data &&
              data.data.map((product) => (
                <Card
                  key={product.id}
                  data={product}
                  onAddToCart={addToCart}
                  cartData={cart}
                  offRate={product.offrate}
                />
              ))}
          </>
        )}
      </div>
      <div>
        <Pagination
          totalCount={data.last_page}
          currentPage={data.current_page}
          pageSize={12}
          onPageChange={onPageChange}
        />
      </div>
    </>
  );
};

export default Products;
